// © Microsoft Corporation. All rights reserved.

/**
 * Returns local storage object, or null if it is not accessible.
 * This is minimal version used by client side inline script.
 */
export function getLocalStorageInline(): Storage {
    try {
        return localStorage;
    } catch (error) {
        return null;
    }
}